import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <nav className="site-footer__links" aria-label="フッターリンク">
        <a
          href="https://yamano-media.com/blog/terms-of-service/"
          target="_blank"
          rel="noopener noreferrer"
        >
          利用規約
        </a>
        <a
          href="https://yamano-media.com/blog/policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          プライバシーポリシー
        </a>
        <Link to="/first-time-guide">初めてのヤマッチ</Link>
        <Link to="/faq">よくある質問</Link>
        <Link to="/community-guidelines">コミュニティガイドライン</Link>
        <Link to="/contact">お問い合わせ</Link>
      </nav>
      <p className="site-footer__copy">ヤマッチ by ヤマノブログ</p>
    </footer>
  );
}

export default Footer;
